// extracted by mini-css-extract-plugin
export default {"title":"Sentiments_title__FYQif","percentage":"Sentiments_percentage__F2gWy","label":"Sentiments_label__U5O+8","description":"Sentiments_description__4xZtZ"};